import { useEffect, useState } from 'react';
import { authService, bancosService, transaccionesService } from '../services/api';
import '../styles/Clientes.css';

const Transacciones = () => {
  const [transacciones, setTransacciones] = useState([]);
  const [bancos, setBancos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    fecha: new Date().toISOString().split('T')[0],
    tipo: 'ingreso',
    concepto: '',
    monto: '',
    banco_id: '',
    banco_destino_id: '',
    referencia: '',
    detalle: ''
  });
  const [editingId, setEditingId] = useState(null);
  const [filtros, setFiltros] = useState({
    tipo: '',
    banco_id: ''
  });

  useEffect(() => {
    cargarDatos();
  }, [filtros]);

  const cargarDatos = async () => {
    await Promise.all([cargarTransacciones(), cargarBancos()]);
  };

  const cargarBancos = async () => {
    try {
      const response = await bancosService.getBancos();
      setBancos(response.data.bancos || []);
    } catch (error) {
      console.error('Error al cargar bancos:', error);
    }
  };

  const cargarTransacciones = async () => {
    try {
      setLoading(true);
      const response = await transaccionesService.getTransacciones(filtros);
      setTransacciones(response.data.transacciones || []);
    } catch (error) {
      console.error('Error al cargar transacciones:', error);
      setError('Error al cargar transacciones');
    } finally {
      setLoading(false);
    }
  };

  const formatMoney = (amount) => {
    return `$${(amount || 0).toLocaleString('es-DO', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })}`;
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleDateString('es-DO');
  };

  const getTipoBadge = (tipo) => {
    const colores = {
      ingreso: '#27ae60',
      egreso: '#e74c3c',
      transferencia: '#3498db'
    };
    return (
      <span style={{
        backgroundColor: colores[tipo] || '#95a5a6',
        color: '#fff',
        padding: '4px 8px',
        borderRadius: '4px',
        fontSize: '0.85rem'
      }}>
        {tipo?.toUpperCase()}
      </span>
    );
  };

  const handleOpenModal = (transaccion = null) => {
    if (transaccion) {
      setEditingId(transaccion.id);
      setFormData({
        fecha: transaccion.fecha || new Date().toISOString().split('T')[0],
        tipo: transaccion.tipo || 'ingreso',
        concepto: transaccion.concepto || '',
        monto: transaccion.monto || '',
        banco_id: transaccion.banco_id || '',
        banco_destino_id: transaccion.banco_destino_id || '',
        referencia: transaccion.referencia || '',
        detalle: transaccion.detalle || ''
      });
    } else {
      setEditingId(null);
      setFormData({
        fecha: new Date().toISOString().split('T')[0],
        tipo: 'ingreso',
        concepto: '',
        monto: '',
        banco_id: '',
        banco_destino_id: '',
        referencia: '',
        detalle: ''
      });
    }
    setShowModal(true);
    setError('');
    setSuccess('');
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditingId(null);
    setFormData({
      fecha: new Date().toISOString().split('T')[0],
      tipo: 'ingreso',
      concepto: '',
      monto: '',
      banco_id: '',
      banco_destino_id: '',
      referencia: '',
      detalle: ''
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    try {
      setLoading(true);

      const user = authService.getCurrentUser();
      const dataToSend = {
        ...formData,
        monto: parseFloat(formData.monto) || 0,
        usuario_id: user?.id || 1
      };

      if (editingId) {
        await transaccionesService.updateTransaccion(editingId, dataToSend);
        setSuccess('Transacción actualizada correctamente');
      } else {
        await transaccionesService.createTransaccion(dataToSend);
        setSuccess('Transacción creada correctamente');
      }

      handleCloseModal();
      await cargarTransacciones();
    } catch (error) {
      console.error('Error al guardar transacción:', error);
      setError(error.response?.data?.message || error.response?.data?.error || 'Error al guardar la transacción');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('¿Estás seguro de que deseas eliminar esta transacción?')) {
      return;
    }

    try {
      setLoading(true);
      await transaccionesService.deleteTransaccion(id);
      setSuccess('Transacción eliminada correctamente');
      await cargarTransacciones();
    } catch (error) {
      console.error('Error al eliminar transacción:', error);
      setError(error.response?.data?.message || error.response?.data?.error || 'Error al eliminar la transacción');
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="loading">Cargando transacciones...</div>;

  return (
    <div className="clientes-page">
      <div className="clientes-header">
        <h1>🔄 Transacciones Bancarias</h1>
        <button className="btn btn-primary" onClick={() => handleOpenModal()}>
          + Nueva Transacción
        </button>
      </div>

      {error && <div className="banner error">{error}</div>}
      {success && <div className="banner success">{success}</div>}

      {/* Filtros */}
      <div className="card" style={{marginBottom: '1rem'}}>
        <div style={{padding: '1rem', display: 'flex', gap: '1rem', alignItems: 'center'}}>
          <div>
            <label style={{marginRight: '0.5rem'}}>Tipo:</label>
            <select
              value={filtros.tipo}
              onChange={(e) => setFiltros({...filtros, tipo: e.target.value})}
              style={{padding: '0.5rem'}}
            >
              <option value="">Todos</option>
              <option value="ingreso">Ingreso</option>
              <option value="egreso">Egreso</option>
              <option value="transferencia">Transferencia</option>
            </select>
          </div>
        </div>
      </div>

      {/* Tabla de Transacciones */}
      <div className="card">
        <div className="card-title">
          Transacciones ({transacciones.length})
        </div>

        {transacciones.length === 0 ? (
          <p style={{padding: '2rem', textAlign: 'center', color: '#666'}}>
            No hay transacciones registradas
          </p>
        ) : (
          <div style={{overflowX: 'auto'}}>
            <table className="table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Fecha</th>
                  <th>Banco</th>
                  <th>Tipo</th>
                  <th>Monto</th>
                  <th>Concepto</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {transacciones.map((trans) => (
                  <tr key={trans.id}>
                    <td>{trans.id}</td>
                    <td>{formatDate(trans.fecha)}</td>
                    <td>{trans.banco || '-'}</td>
                    <td>{getTipoBadge(trans.tipo)}</td>
                    <td style={{
                      fontWeight: 'bold',
                      color: trans.tipo === 'ingreso' ? '#27ae60' : '#e74c3c'
                    }}>
                      {trans.tipo === 'ingreso' ? '+' : '-'} {formatMoney(trans.monto)}
                    </td>
                    <td>{trans.concepto || '-'}</td>
                    <td>
                      <button
                        className="btn-icon"
                        title="Editar"
                        onClick={() => handleOpenModal(trans)}
                      >
                        ✏️
                      </button>
                      <button
                        className="btn-icon"
                        title="Eliminar"
                        onClick={() => handleDelete(trans.id)}
                        style={{marginLeft: '0.5rem'}}
                      >
                        �️
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Modal para crear/editar transacción */}
      {showModal && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>{editingId ? 'Editar Transacción' : 'Nueva Transacción'}</h2>
              <button className="modal-close" onClick={handleCloseModal}>×</button>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="form-grid">
                <div className="form-group">
                  <label>Fecha *</label>
                  <input
                    type="date"
                    name="fecha"
                    value={formData.fecha}
                    onChange={handleInputChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Tipo *</label>
                  <select
                    name="tipo"
                    value={formData.tipo}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="ingreso">Ingreso</option>
                    <option value="egreso">Egreso</option>
                    <option value="transferencia">Transferencia</option>
                  </select>
                </div>

                <div className="form-group">
                  <label>Banco Origen *</label>
                  <select
                    name="banco_id"
                    value={formData.banco_id}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">Seleccione un banco</option>
                    {bancos.map(banco => (
                      <option key={banco.id} value={banco.id}>
                        {banco.nombre}
                      </option>
                    ))}
                  </select>
                </div>

                {formData.tipo === 'transferencia' && (
                  <div className="form-group">
                    <label>Banco Destino</label>
                    <select
                      name="banco_destino_id"
                      value={formData.banco_destino_id}
                      onChange={handleInputChange}
                    >
                      <option value="">Seleccione un banco</option>
                      {bancos.map(banco => (
                        <option key={banco.id} value={banco.id}>
                          {banco.nombre}
                        </option>
                      ))}
                    </select>
                  </div>
                )}

                <div className="form-group">
                  <label>Monto *</label>
                  <input
                    type="number"
                    name="monto"
                    value={formData.monto}
                    onChange={handleInputChange}
                    placeholder="0.00"
                    step="0.01"
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Referencia</label>
                  <input
                    type="text"
                    name="referencia"
                    value={formData.referencia}
                    onChange={handleInputChange}
                    placeholder="Número de referencia"
                  />
                </div>

                <div className="form-group" style={{gridColumn: '1 / -1'}}>
                  <label>Concepto *</label>
                  <input
                    type="text"
                    name="concepto"
                    value={formData.concepto}
                    onChange={handleInputChange}
                    placeholder="Descripción de la transacción"
                    required
                  />
                </div>

                <div className="form-group" style={{gridColumn: '1 / -1'}}>
                  <label>Detalle</label>
                  <textarea
                    name="detalle"
                    value={formData.detalle}
                    onChange={handleInputChange}
                    placeholder="Detalles adicionales"
                    rows="3"
                  />
                </div>
              </div>

              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={handleCloseModal}>
                  Cancelar
                </button>
                <button type="submit" className="btn btn-primary" disabled={loading}>
                  {loading ? 'Guardando...' : (editingId ? 'Actualizar' : 'Crear')}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Transacciones;
